import React, { Fragment, useState } from "react";
import PropTypes from 'prop-types';
import { SvgIcon, lighten, makeStyles } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import ProductModal from "./ProductModal";
import "./ProductModalList.scss"

const useStyles = makeStyles(theme => ({
  textColor: {
    color: theme.palette.primary.main,
  },
  background: {
    backgroundColor: lighten(theme.palette.primary.main, 0.92),
  },
}));

export default function ProductModalList({ data, carriers, category, handleSubmitClick}) {
  const classes = useStyles();

  const [productModalShow, setProductModalShow] = useState(false);
  const [modalContentIndex, setModalContentIndex] = useState(null);

  const handleProductModalClose = (scroll) => {
    handleModalContent(null);
    setProductModalShow(false);
    if (scroll) {
      handleSubmitClick();
    }
  };

  const handleProductModalShow = (index) => {
    handleModalContent(index);
    setProductModalShow(true);
  };

  const handleModalContent = (index) => {
    setModalContentIndex(index);
  };

  return (
      <div className="modal-list-container">
        <Fragment>
          {data.map((p, index) => {
            return <button className={`button-pill ${classes.background}`} key={index} onClick={() => handleProductModalShow(index)}>
                        <SvgIcon component={p.icon} color="primary"/>
                        <span className={`title ${classes.textColor}`}>{p.buttonTitle}</span>
                        <InfoIcon color="primary"/>
                      </button>
            }
          )}
          {productModalShow && 
          <ProductModal
            productModalShow={productModalShow}
            handleProductModalClose={handleProductModalClose}
            productData={data[modalContentIndex].modalContent}
            carriers={carriers}
            category={category}
          />
          }
        </Fragment>
      </div>
  )
}

ProductModalList.propTypes = {
  data: PropTypes.array,
}



// WEBPACK FOOTER //
// ./src/components/LandingPages/About/Common/ProductModalList.js